import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import Sky from "../scene/Sky";

function StartScreen() {
  return (
    <>
      <Canvas className="login-canvas" concurrent>
        <ambientLight intensity={1} />
        <directionalLight />
        <directionalLight position={[1, 1, 1]} color="#04030b" />
        <Suspense fallback={null}>
          <Sky move={true} />
        </Suspense>
      </Canvas>
    </>
  );
}

export default StartScreen;
